function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "slideshow-3-line",
  clipPath: "url(#clip0_1988_3723)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M11.9173 16H11.4173V16.5V18.3333V18.8333H11.9173H15.084V19.6667H6.91732V18.8333H10.084H10.584V18.3333V16.5V16H10.084H2.75065C2.64014 16 2.53416 15.9561 2.45602 15.878C2.37788 15.7998 2.33398 15.6938 2.33398 15.5833V3.66667C2.33398 3.55616 2.37788 3.45018 2.45602 3.37204C2.53416 3.2939 2.64014 3.25 2.75065 3.25H19.2507C19.3612 3.25 19.4671 3.2939 19.5453 3.37204C19.6234 3.45018 19.6673 3.55616 19.6673 3.66667V15.5833C19.6673 15.6938 19.6234 15.7998 19.5453 15.878C19.4671 15.9561 19.3612 16 19.2507 16H11.9173ZM3.66732 4.08333H3.16732V4.58333V14.6667V15.1667H3.66732H18.334H18.834V14.6667V4.58333V4.08333H18.334H3.66732ZM9.66732 7.7581L12.7788 9.625L9.66732 11.4919V7.7581Z",
  fill: "currentColor",
  stroke: "currentColor"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1988_3723"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "currentColor"
})));
function SvgStreamingTvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamingTvIcon);
export default __webpack_public_path__ + "static/media/Streaming TV Icon.4d6134db26a71a453bbb85c7db827b33.svg";
export { ForwardRef as ReactComponent };